import { render, staticRenderFns } from "./JTTemplateUpload.vue?vue&type=template&id=376898be&scoped=true"
import script from "./JTTemplateUpload.vue?vue&type=script&lang=js"
export * from "./JTTemplateUpload.vue?vue&type=script&lang=js"
import style0 from "./JTTemplateUpload.vue?vue&type=style&index=0&id=376898be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376898be",
  null
  
)

export default component.exports